import { Injectable } from '@angular/core';
import { parseError } from '@new/common/utils/error-parser';
import { RemoteData } from '@new/common/utils/remote-data';
import { Action, Selector, State, type StateContext } from '@ngxs/store';
import { Observable } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { ListPoolsGQL } from '../../lib/services';
import { type Pools } from '../../lib/types';
import { LoadPools, LoadPoolsFailure, LoadPoolsSuccess } from './pools.actions';

export interface PoolsStateModel {
  pools: RemoteData<Pools>;
}

@State<PoolsStateModel>({
  name: 'newPools',
  defaults: {
    pools: {
      requestState: 'initial'
    }
  }
})
@Injectable({
  providedIn: 'root'
})
export class PoolsState {
  constructor(private readonly listPoolsService: ListPoolsGQL) {}

  @Selector()
  public static pools(state: PoolsStateModel): RemoteData<Pools> {
    return state.pools;
  }

  @Action(LoadPools, { cancelUncompleted: true })
  public loadPools(ctx: StateContext<PoolsStateModel>): Observable<void> {
    ctx.patchState({ pools: { requestState: 'loading' } });

    return this.listPoolsService.fetch().pipe(
      switchMap(res => ctx.dispatch(new LoadPoolsSuccess(res.data.pools))),
      catchError((err: unknown) =>
        ctx.dispatch(new LoadPoolsFailure(parseError(err)))
      )
    );
  }

  @Action(LoadPoolsSuccess)
  public loadPoolsSuccess(
    ctx: StateContext<PoolsStateModel>,
    { pools }: LoadPoolsSuccess
  ): void {
    ctx.patchState({
      pools: { data: pools, requestState: 'success' }
    });
  }

  @Action(LoadPoolsFailure)
  public loadPoolsFailure(
    ctx: StateContext<PoolsStateModel>,
    { error }: LoadPoolsFailure
  ): void {
    ctx.patchState({
      pools: { requestState: 'failure', error }
    });
  }
}
